import { render, staticRenderFns } from "./ExamStudent.vue?vue&type=template&id=c56d87fe"
import script from "./ExamStudent.vue?vue&type=script&lang=js"
export * from "./ExamStudent.vue?vue&type=script&lang=js"
import style0 from "./ExamStudent.vue?vue&type=style&index=0&id=c56d87fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports